import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=5c4f505f"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"
import style0 from "./system-manage.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports